import { add } from "date-fns";

const getNextDate = (date: string) => {
  const value = new Date(date);
  const nextDate = add(value, { days: 1 });
  return nextDate.toISOString().slice(0, 10);
};

export default getNextDate;
